"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
var _default = exports.default = {
  computed: {
    getTableOn: function getTableOn() {
      return this.$$filterObjectByKey(this.$listeners, ['rowDblclick', 'row-click']);
    }
  },
  /* 方法 当前组件可使用的方法 */
  methods: {
    /**
     * @description: row-click 当某一行被双击时会触发该事件
     * @param { Object } row 行数据
     * @param { Object } column 列数据
     * @param { Object } event 点击事件
     * @return { void }
     */
    rowDblclick: function rowDblclick(row) {
      if (this.table.chooseMode !== 'single') {
        var _this$$refs$elTable;
        var a = this.getSelection();
        var b = a.find(function (item) {
          return JSON.stringify(item) === JSON.stringify(row);
        });
        (_this$$refs$elTable = this.$refs['el-table']) === null || _this$$refs$elTable === void 0 || _this$$refs$elTable.toggleRowSelection(row, !b);
      } else {
        this.tableSelection = [row];
      }
      this.$$listenersEmit.apply(this, ['row-dblclick'].concat(Array.prototype.slice.call(arguments)));
    },
    /**
     * @description: row-click 当某一行被点击时会触发该事件
     * @param { Object } row 行数据
     * @param { Object } column 列数据
     * @param { Object } event 点击事件
     * @return { void }
     */
    rowClick: function rowClick(row) {
      var _arguments = arguments,
        _this = this;
      this.$$debounce(function () {
        if (_this.isSingle) _this.tableSelectRadio(row);
        _this.$$listenersEmit.apply(_this, ['row-click'].concat((0, _toConsumableArray2.default)(_arguments)));
      });
    }
  }
};